import { ReactNode } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { formatDateTimeDE } from '../../../../lib/utils/date';
import { PaymentMethod } from '../../../offer-checkout/constants/payment-method.enum';
import { OfferAcceptanceResponseDto } from '../../types/response';
import { OfferFormValues } from '../offer-form/offer-form.schema';

export interface OfferAcceptanceProofProps {
  control: Control<OfferFormValues>;
  mail: string;
  acceptance: OfferAcceptanceResponseDto;
}

const ProofRow = ({ label, children }: { label: string; children: ReactNode }) => (
  <div className="flex justify-between gap-4 text-[14px]">
    <span className="text-[#888]">{label}</span>
    <span className="text-right font-bold text-[#12282A]">{children}</span>
  </div>
);

/** What the customer agreed to on accept – proof, never part of a correction. */
const OfferAcceptanceProof = ({ control, mail, acceptance }: OfferAcceptanceProofProps) => {
  const paymentMethod = useWatch({ control, name: 'paymentMethod' });
  const isSepaWithoutMandate = paymentMethod === PaymentMethod.SEPA && !acceptance.sepaMandateAccepted;

  return (
    <aside className="sticky top-5 flex flex-col gap-4 rounded-2xl border border-[#E4E7EC] bg-white p-6">
      <div className="flex flex-col gap-1">
        <span className="text-[18px] font-bold text-[#12282A]">Annahme</span>
        <span className="text-[12px] text-[#888]">Nachweis vom Annehmen – nicht änderbar.</span>
      </div>
      <div className="flex flex-col gap-2">
        <ProofRow label="E-Mail (Login)">{mail}</ProofRow>
        <ProofRow label="Angenommen am">{formatDateTimeDE(acceptance.acceptedAt)}</ProofRow>
        <ProofRow label="IP-Adresse">{acceptance.ip}</ProofRow>
        <ProofRow label="AGB">akzeptiert</ProofRow>
        <ProofRow label="SEPA-Lastschriftmandat">{acceptance.sepaMandateAccepted ? 'erteilt' : 'nicht erteilt'}</ProofRow>
      </div>
      {isSepaWithoutMandate && (
        <p className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-[12px] text-amber-700">
          Beim Annehmen wurde kein SEPA-Lastschriftmandat erteilt. Hol es beim Kunden ein, bevor du auf SEPA umstellst.
        </p>
      )}
    </aside>
  );
};

export default OfferAcceptanceProof;
